var map = {
	"./ar.json": [
		1925,
		925
	],
	"./de.json": [
		1873,
		873
	],
	"./en.json": [
		8053
	],
	"./es.json": [
		1406,
		406
	],
	"./fa.json": [
		6807,
		807
	],
	"./fr.json": [
		7222,
		222
	],
	"./ru.json": [
		8335,
		335
	],
	"./tr.json": [
		2584
	],
	"./uk.json": [
		230,
		230
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8631;
module.exports = webpackAsyncContext;